import React from "react";
import EmptyImage from "../../assets/images/svg/safety-box.svg";
import ButtonLink from "../elements/ButtonLink";

const EmptySchoolList = () => {
  return (
    <div className="text-center mx-auto mt-20 lg:mt-28 mb-20 lg:mb-28">
      <img src={EmptyImage} alt="Empty" className="w-20 mx-auto" />
      <p className="mt-6 lg:mt-8 text-sm lg:text-base w-11/12 lg:w-6/12 xl:w-5/12 mx-auto text-default font-semibold">
        No Course available in this region at the moment. Check other course
        available or reach out to our customer support.
      </p>
      <div className="mt-8">
        <ButtonLink title={"Browse All Courses"} url="/global" />
      </div>
    </div>
  );
};

export default EmptySchoolList;
